var React = require('react');

var State = require('./state');
var Store = require('./store');
var Quiz  = require('./quiz');

var Main = React.createClass({
  propTypes : {
    challengeId: React.PropTypes.number.isRequired,
    stageId: React.PropTypes.number.isRequired,
    questions: React.PropTypes.object.isRequired,
    csrfToken: React.PropTypes.string.isRequired,
    submitLabel: React.PropTypes.string.isRequired
  },

  componentDidMount: function () {
		State.on('update', this._updateState);
    State.trigger('initialize', this.props.questions, this.props.stageId);
	},

  render: function() {
    var state = State.get()[this.props.stageId];
    return (
      <Quiz {...this.props} {...state} />
    );
  },

  _updateState: function() {
    this.forceUpdate();
  }
});

module.exports = Main;



// WEBPACK FOOTER //
// ./src/advocate/stages/quiz/main.jsx